export const NODE_TYPES = ['area', 'goal', 'result', 'task', 'idea', 'routine', 'project', 'section', 'list'] as const;
export type NodeType = (typeof NODE_TYPES)[number];

export const NODE_STATUSES = ['idea', 'active', 'waiting', 'done', 'dropped'] as const;
export type NodeStatus = (typeof NODE_STATUSES)[number];

/** Statuses hidden from lists unless "show completed" is on (PRD 6.6). */
export const CLOSED_STATUSES: readonly NodeStatus[] = ['done', 'dropped'];

export const ENERGY_LEVELS = ['low', 'med', 'high'] as const;
export type Energy = (typeof ENERGY_LEVELS)[number];

export const ASSIGNEE_TYPES = ['human', 'agent'] as const;
export type AssigneeType = (typeof ASSIGNEE_TYPES)[number];

export const CHECK_CADENCES = ['daily', 'weekly', 'on_due'] as const;
export type CheckCadence = (typeof CHECK_CADENCES)[number];

export const USER_KINDS = ['human', 'agent'] as const;
export type UserKind = (typeof USER_KINDS)[number];

export const NOTE_KINDS = ['human', 'agent'] as const;
export type NoteKind = (typeof NOTE_KINDS)[number];

export const REVIEW_TYPES = ['daily_prep', 'weekly_review'] as const;
export type ReviewType = (typeof REVIEW_TYPES)[number];

export const ROUTINE_OCCURRENCE_STATUSES = ['open', 'done', 'skipped'] as const;
export type RoutineOccurrenceStatus = (typeof ROUTINE_OCCURRENCE_STATUSES)[number];

export const PERMISSION_REQUEST_STATUSES = ['pending', 'approved', 'rejected'] as const;
export type PermissionRequestStatus = (typeof PERMISSION_REQUEST_STATUSES)[number];

/** External actions that need Andreas's approval (PRD 7.1). */
export const PERMISSION_ACTIONS = ['send', 'purchase', 'trade', 'publish', 'other'] as const;
export type PermissionAction = (typeof PERMISSION_ACTIONS)[number];

export const PRIORITIES = [1, 2, 3] as const;
export type Priority = (typeof PRIORITIES)[number];
